import { BKJListItem } from '@bookjane2/bookjane-design-library';
import styled from 'styled-components';

export const CustomerGroupHeader = styled.div`
  ${({ theme }) => theme.fonts.PoppinsTextMedium};
  color: ${({ theme }) => theme.colors.TextDarkGrey};
  font-size: 14px;
  list-style: none;
  height: 38px;
  padding: 0 16px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: white;
  transition: background-color 100ms linear;

  &:nth-child(odd) {
    background-color: ${({ theme }) => theme.colors.Grey1};
  }
`;

export const CustomerOptionListItem = styled(BKJListItem)`
  ${({ theme }) => theme.fonts.PoppinsText};
  display: flex;
  gap: 0px;
  padding: 0 4px 0 35px;

  p:nth-of-type(1) {
    max-width: 50%;
    min-width: 0;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    padding-right: 10px;
  }
  p:nth-of-type(2) {
    flex: 1 1 50%;
    margin-left: 0;
    min-width: 0;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    line-height: 24px;
  }
`;

export const NoResults = styled.div`
  ${({ theme }) => theme.fonts.PoppinsText};
  color: ${({ theme }) => theme.colors.TextDarkGrey};
  font-size: 14px;
  padding: 16px;
  background-color: ${({ theme }) => theme.colors.Grey1};
`;
